import useSWR from 'swr'
import API from "../../../utils/api";
import { WITHDRAW } from '@app/constants/APIKEYS.tsx';
import { useToken } from '@app/hooks';


const M_KEY = WITHDRAW

const fetchKey = ( ) =>
  `${M_KEY}`;

export function useWithdrawList() {
  const {data: token} = useToken();

  const KEY = fetchKey();

  const fetcher = () => fetchAPI(KEY, token);
  const {data, mutate} = useSWR(token ? `${KEY}` : '', fetcher,
    {
      revalidateOnFocus: true,
      // refreshInterval: 60000,
      // revalidateOnReconnect: true,
    });

  return {WithdrawList: data?.list, WithdrawListMutate: mutate, total: data?.total};
}

async function fetchAPI(KEY: string, token:any) {
  try {
    const response = await API.get(`${KEY}`, token + '', {});
    return {list: response?.result, total: response?.result?.totalCount};
  } catch (error) {
    console.error('Failed to fetch Referred User List ===> ', error);
    return {list: [], total: 0};
  }
}